<div class="modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main" *ngIf="factura">#{{ factura.id }} - {{ factura.cliente }}</div>
          <div class="title-sub"></div>
        </div>
        <div class="icon-btn ghost"></div>
      </div>
    </div>
  </ion-header>

  <ion-content class="menu-content">

    <!-- Top Actions: Edit & Delete -->
    <div class="top-actions" *ngIf="viewMode !== 'minimal'">
      <div class="action-card edit" (click)="edit()" *ngIf="permissions?.facturacion?.rl_fact_paq === true">
        <ion-icon name="create-outline"></ion-icon>
        <span>Editar</span>
      </div>
      <div class="action-card delete" (click)="delete()" *ngIf="permissions?.facturacion?.rl_fact_paq === true">
        <ion-icon name="trash-outline"></ion-icon>
        <span>Eliminar</span>
      </div>
    </div>

    <!-- Quick Actions -->
    <div class="section-label" *ngIf="viewMode !== 'minimal'">Acciones rápidas</div>
    <div class="quick-actions">
      <div class="circle-action" (click)="viewPdf()" *ngIf="viewMode !== 'minimal'">
        <div class="circle-icon view-pdf">
          <ion-icon name="eye-outline"></ion-icon>
        </div>
        <span class="circle-label">Ver Factura</span>
      </div>
      <div class="circle-action" (click)="registerFiscal()" *ngIf="permissions?.facturacion?.rl_fact_paq === true">
        <div class="circle-icon fiscal">
          <ion-icon name="receipt-outline"></ion-icon>
        </div>
        <span class="circle-label">{{ factura?.fechaPago ? 'Editar Pago' : 'Registrar Pago' }}</span>
      </div>
    </div>

    <!-- Items List -->
    <div class="section-label">Ítems de la Factura</div>
    <div class="items-list-container">
      <div *ngIf="isLoadingItems" class="item-loading">
        <ion-spinner name="crescent" color="primary"></ion-spinner>
        <p>Cargando ítems...</p>
      </div>

      <div *ngIf="!isLoadingItems && items.length > 0" class="items-grid">
        <div class="item-header">
          <span class="col-desc">Descripción</span>
          <span class="col-cant">Cant</span>
          <span class="col-price">Total</span>
        </div>
        <div class="item-detail-row" *ngFor="let item of items">
          <div class="item-desc">
            <span class="desc-text">{{ item.descripcion }}</span>
            <span class="unit-price">P.U: B/. {{ item.precio_unitario | number:'1.2-2' }}</span>
          </div>
          <div class="item-cant">{{ item.cantidad }}</div>
          <div class="item-tot">B/. {{ item.precio_total | number:'1.2-2' }}</div>
        </div>

        <!-- Integrated Finance Summary -->
        <div class="finance-summary-section">
          <div class="finance-sum-row">
            <span>Subtotal</span>
            <span>B/. {{ factura.subtotal | number:'1.2-2' }}</span>
          </div>
          <div class="finance-sum-row" *ngIf="factura.itbms > 0">
            <span>ITBMS (7%)</span>
            <span>B/. {{ factura.itbms | number:'1.2-2' }}</span>
          </div>
          <div class="finance-sum-divider"></div>
          <div class="finance-sum-row total-row">
            <span>Total a Pagar</span>
            <span class="total-val">B/. {{ factura.total | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <div *ngIf="!isLoadingItems && items.length === 0" class="empty-items">
        <p>No se encontraron ítems vinculados.</p>
      </div>
    </div>

    <!-- Details -->
    <div class="section-label">Detalles de Facturación</div>
    <div class="info-card">
      <div class="info-row">
        <ion-icon name="calendar-outline" color="secondary"></ion-icon>
        <span>Fecha de Emisión: <strong>{{ factura.fecha | date:'dd/MM/yyyy' }}</strong></span>
      </div>
      <div class="info-row" *ngIf="factura.direccion">
        <ion-icon name="location-outline" color="primary"></ion-icon>
        <span>{{ factura.direccion }}</span>
      </div>
      <div class="info-row">
        <ion-icon name="person-outline" color="medium"></ion-icon>
        <span>Creado por: <strong>{{ factura.usuario }}</strong></span>
      </div>
      <div class="info-row" *ngIf="factura.cotizacionId">
        <ion-icon name="link-outline" color="tertiary"></ion-icon>
        <span>Cotización vinculada: #{{ factura.cotizacionId }}</span>
      </div>
      <div class="info-row" *ngFor="let oc of vinculatedOcs" style="display: flex; align-items: center;">
        <ion-icon name="receipt-outline" style="color: #0984e3;"></ion-icon>
        <span>OC vinculada: <strong>{{ oc }}</strong></span>
        <ion-button fill="clear" size="small" (click)="copyToClipboard(oc)"
          style="margin: 0 0 0 8px; height: 24px; width: 24px; --padding-start: 0; --padding-end: 0;">
          <ion-icon name="copy-outline" slot="icon-only" style="font-size: 14px; color: #7f8c8d;"></ion-icon>
        </ion-button>
      </div>
      <div class="info-row" *ngIf="factura.paquete">
        <ion-icon name="gift-outline" style="color: #6c5ce7;"></ion-icon>
        <span>Paquete: <strong>{{ factura.paquete }}</strong></span>
      </div>
      <div class="info-row" *ngIf="factura.fiscalInvoice">
        <ion-icon name="document-lock-outline" style="color: #00b894;"></ion-icon>
        <span>Factura Fiscal: <strong>{{ factura.fiscalInvoice }}</strong></span>
      </div>
      <div class="info-row" *ngIf="factura.fechaPago">
        <ion-icon name="cash-outline" style="color: #27ae60;"></ion-icon>
        <span>Pago: <strong>{{ factura.tipoPago }}</strong> el <strong>{{ factura.fechaPago | date:'dd/MM/yyyy'
            }}</strong></span>
      </div>
    </div>

  </ion-content>

  <ion-footer class="ion-no-border premium-list-footer"></ion-footer>
</div>